(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bn26-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.BN26) return;
    const t = (s) => Date.parse(s);
    const END = t('2026-12-01T00:00:00+01:00');
    // Order matters: the first matching phase wins, so Singles Day sits before Black November.
    const PHASES = [
      { id: 'pre', start: -Infinity, end: t('2026-10-29T19:00:00+01:00') },
      { id: 'singles_day', start: t('2026-11-11T00:00:00+01:00'), end: t('2026-11-12T00:00:00+01:00') },
      { id: 'black_november', start: t('2026-10-29T19:00:00+01:00'), end: t('2026-11-22T19:00:00+01:00') },
      { id: 'black_week', start: t('2026-11-22T19:00:00+01:00'), end: t('2026-11-26T19:00:00+01:00'), deadline: END },
      { id: 'black_friday', start: t('2026-11-26T19:00:00+01:00'), end: END },
    ];
    const KEY = 'bn26-preview-phase';
    const LOADED = Date.now();
    const canPreview = () => {
      const role = window.Shopify && Shopify.theme && Shopify.theme.role;
      return (role && role !== 'main') || (window.Shopify && Shopify.designMode);
    };
    const previewPhase = () => {
      if (!canPreview()) return null;
      try {
        const q = new URLSearchParams(location.search).get('bn26');
        if (q === 'live') sessionStorage.removeItem(KEY);
        else if (q && PHASES.some((p) => p.id === q)) sessionStorage.setItem(KEY, q);
        return sessionStorage.getItem(KEY);
      } catch (e) {
        return null;
      }
    };
    const current = (now) => {
      const forced = previewPhase();
      if (forced) return PHASES.find((p) => p.id === forced);
      return PHASES.find((p) => now >= p.start && now < p.end) || { id: 'over', end: END };
    };

    let active = null;
    const apply = () => {
      active = current(Date.now());
      document.documentElement.setAttribute('data-bn26', active.id);
      // Only write when a value changes, so the 1-second tick causes no style work on its own
      document.querySelectorAll('[data-bn26-root]').forEach((root) => {
        const over = active.id === 'over';
        if (root.hidden !== over) root.hidden = over;
        root.querySelectorAll('[data-bn26-phase]').forEach((el) => {
          const hide = !el.getAttribute('data-bn26-phase').split(' ').includes(active.id);
          if (el.hidden !== hide) el.hidden = hide;
        });
      });
    };

    const pad = (n) => String(n).padStart(2, '0');
    const set = (el, v) => {
      if (!el || el.textContent === v) return;
      el.textContent = v;
      // Web Animations API: no forced reflow on every tick
      if (el.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 350, easing: 'ease-out' });
      }
    };
    // ponytail: apply() every tick also covers cards added later (AJAX, variant change, cart drawer); it is a few dozen nodes
    const tick = () => {
      apply();
      // Previewing a phase that has not started yet: run the clock as if it started when the page loaded.
      const now = previewPhase() && active.start > LOADED ? active.start + (Date.now() - LOADED) : Date.now();
      const left = Math.max(0, (active.deadline || active.end) - now);
      const s = Math.floor(left / 1000);
      const parts = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      const showSeconds = s < 48 * 3600;
      document.querySelectorAll('[data-bn26-countdown]').forEach((cd) => {
        if (cd.closest('[hidden]')) return;
        const a = (k) => cd.getAttribute('data-' + k);
        ['d', 'h', 'm', 's'].forEach((u) => {
          const num = cd.querySelector('[data-unit="' + u + '"]');
          if (!num) return;
          const hide = (u === 'd' && parts.d === 0) || (u === 's' && !showSeconds);
          if (num.parentElement.hidden !== hide) num.parentElement.hidden = hide;
          if (hide) return;
          set(num, u === 'd' ? String(parts.d) : pad(parts[u]));
          // "1 dag" / "1 time": the long labels have a singular form
          const lbl = num.nextElementSibling;
          const one = a('one-' + u);
          if (lbl && one) {
            const want = parts[u] === 1 ? one : a('many-' + u);
            if (lbl.textContent !== want) lbl.textContent = want;
          }
        });
        const words = [];
        if (parts.d > 0) words.push(parts.d + ' ' + a(parts.d === 1 ? 'aria-day' : 'aria-days'));
        words.push(parts.h + ' ' + a(parts.h === 1 ? 'aria-hour' : 'aria-hours'));
        words.push(parts.m + ' ' + a(parts.m === 1 ? 'aria-minute' : 'aria-minutes'));
        const label = a('label-prefix') + ' ' + words.join(' ');
        if (cd.getAttribute('aria-label') !== label) cd.setAttribute('aria-label', label);
        if (cd.hasAttribute('data-pending')) cd.removeAttribute('data-pending');
      });
    };

    // "Vælg sættet": click the matching variant option of the product form on the same page
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bn26-pick]');
      if (!btn) return;
      const value = btn.getAttribute('data-bn26-pick');
      // Same product form as the card: the main product section, or the quick view it sits in
      const scope = btn.closest('.shopify-section, dialog, [role="dialog"]') || document;
      const input = [...scope.querySelectorAll('input[type="radio"]')].find((i) => i.value.startsWith(value) && !i.closest('sticky-atc-bar'));
      const label = input && document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (label) {
        e.preventDefault();
        label.click();
      }
    });

    window.BN26 = { apply, tick, phases: PHASES };
    const start = () => {
      tick();
      setInterval(tick, 1000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    // Decorative motion waits until the page has painted, so it never competes with the LCP image
    const ready = () => setTimeout(() => document.documentElement.classList.add('bn26-ready'), 800);
    if (document.readyState === 'complete') ready();
    else addEventListener('load', ready);
  })();
  } catch(e) { console.error(e); }
})();

})();
